module.exports = __webpack_public_path__ + "img/people_group_dark.05dfe472.svg";